<template>
  <div class="wdig-feedback">
    <template v-if="yesNo == true">
      <p>Did you find what you were looking for?</p>
      <div class="form-inline yesNo">
        <button type="submit" class="yes btn btn-primary" @click="yes">
          Yes
        </button>
        <button type="submit" class="no btn btn-primary" @click="no">No</button>
      </div>
    </template>
    <p v-if="thanks">Thank you for your feedback.</p>
    <form v-if="details" :action="action" method="post" name="form" role="form"  class="details fbform">
      <input name="recipient" type="hidden" value="WDIGTool@seattle.gov" />
      <input name="subject" type="hidden" value="WDIG Feedback" />
      <input name="return_url" type="hidden" :value="returnURL" />
      <input type="text" name="password_new" value="" tabindex="-1" autocomplete="false" /> 
      <input type="text" name="email_new" value="web.admin@seattle.gov" tabindex="-1" autocomplete="false" />
      <input type="text" name="Email_Address" value="WDIGTool@seattle.gov" tabindex="-1" autocomplete="false" /> 

      <p>Please tell us more.</p>
      <div class="field-group">
        <label for="f2">What did you not find today?</label
        ><input
          id="f2"
          type="text"
          name="What did you not find today?"
          class="form-control"
          placeholder=""
        />
      </div>
      <div class="field-group">
        <label for="f3">Was there any incorrect or missing information?</label
        ><input
          id="f3"
          type="text"
          name="Was there any incorrect or missing information?"
          class="form-control"
          placeholder=""
        />
      </div>
      <div class="field-group">
        <label for="f6">Anything else you want us to know:</label
        ><input
          id="f6"
          type="text"
          name="Anything else you want us to know:"
          class="form-control"
        />
      </div>
      <div class="field-group">
        <p>
          <input
            type="submit"
            name="submit"
            class="btn btn-primary"
            value="Submit"
          />
        </p>
        <p class="privacyStatement">
          Personal information entered on this form is subject to Washington
          Public Records Act, and may be subject to disclosure to a third-party
          requestor. At the City of Seattle, we are committed to protecting your
          privacy and will ensure that any disclosures are done according to
          law. To learn more about how this information is managed please see
          our
          <a href="https://www.seattle.gov/tech/initiatives/privacy"
            >Privacy Statement</a
          >.
        </p>
      </div>
    </form>
  </div>
</template>
 
<script>
export default {
  name: "feedback-form",
  data() {
    return {
      yesNo: true,
      thanks: false,
      details: false,
    };
  },
  computed: {
    action() {
      // return 'http://honeypot/FormHandler/FeedbackHandler'
      // return 'http://ditwinw520/honeypot/formhandler/FeedbackHandler'
      return 'https://web6.seattle.gov/doit/formhandler/feedback'
    },
    returnURL() {
      let location = window.location.href

      let url = location.split('#')[0] + '#/feedbackConfirmation'

      return url
    }
  },
  methods: {
    yes() {
      this.thanks = true;
      this.yesNo = false;
      console.log("yes");
    },
    no() {
      this.yesNo = false;
      this.details = true;
      console.log("no");
    },
  },
};
</script> 

<style lang="scss">
.wdig-feedback {
  margin-top: 60px;

  .btn {
    color: #fff;
    font-size: 1em;
    transition: all 0.3s;
    margin-bottom: 0px;
    border-width: 1px;
    white-space: normal;
    border: 2px solid;
    border-color: #003da5;
    background-color: #003da5;
    color: #fff;

    &.yes {
      margin-right: 10px;
    }
  }
}




.fbform {
  font-family: "Open Sans"; }
  .fbform input[name="password_new"],
  .fbform input[name="email_new"],
    .fbform input[name="password1"],
  .fbform input[name="email1"],
      .fbform input[name="Email_Address"],
  .fbform input[name="Email_Address"]
  {
    visibility: hidden; 
    
    }
  .fbform h2, .fbform h3 {
    font-family: "Seattle Text";
    font-weight: bold; }
  .fbform .field-group {
    margin-bottom: 30px; }
  .fbform label, .fbform legend {
    border: 0; }
    .fbform label[required="required"]:after, .fbform legend[required="required"]:after {
      content: '*';
      color: #E4002B;
      font-size: 14px;
      display: inline;
      margin-left: 3px;
      line-height: 24px;
      font-weight: normal;
      vertical-align: top; }
  .fbform label, .fbform fieldset legend {
    font-weight: bold;
    font-size: 1em;
    margin-bottom: 4px; }
  .fbform input + label {
    font-weight: normal; }
  .fbform fieldset legend ~ input[type="checkbox"] + label:not(:last-of-type) {
    margin-bottom: 5px; }
  .fbform input[type="date"], .fbform input[type="email"], .fbform input[type="number"], .fbform input[type="password"], .fbform input[type="tel"], .fbform input[type="text"], .fbform input[type="time"] {
    height: 34px;
    border-radius: 0px;
    border-color: #bababa;
    padding: .75rem .5rem; }
  .fbform input[type="checkbox"] {
    margin-right: 8px;
    position: absolute;
    z-index: -1;
    opacity: 0; }
    .fbform input[type="checkbox"] + label {
      position: relative;
      padding-left: 24px;
      cursor: pointer; }
      .fbform input[type="checkbox"] + label::before, .fbform input[type="checkbox"] + label::after {
        position: absolute;
        top: .3rem;
        left: 0;
        display: block;
        content: ""; }
      .fbform input[type="checkbox"] + label::before {
        border: 1px solid #dad9d6;
        width: 14px;
        height: 14px;
        pointer-events: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-color: #ebebeb; }
      .fbform input[type="checkbox"] + label::after {
        background-color: #ebebeb;
        transition: background-color .25s; }
    .fbform input[type="checkbox"]:checked + label::after {
      margin-top: .25rem;
      margin-left: .25rem;
      left: 0px;
      top: 2px;
      width: 6px;
      height: 9px;
      border: solid #000;
      border-width: 0 2px 2px 0;
      -webkit-transform: rotate(40deg);
      -ms-transform: rotate(40deg);
      transform: rotate(35deg); }
    .fbform input[type="checkbox"]:focus:not(:checked) + .custom-control-label::before {
      border-color: #80bdff;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
    .fbform input[type="checkbox"]:focus + label::before {
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
  .fbform input[type="radio"] {
    margin-right: 8px;
    position: absolute;
    z-index: -1;
    opacity: 0; }
    .fbform input[type="radio"] + label {
      position: relative;
      padding-left: 24px;
      cursor: pointer; }
      .fbform input[type="radio"] + label::before, .fbform input[type="radio"] + label::after {
        border-radius: 50%;
        position: absolute;
        top: .25rem;
        left: 0;
        display: block;
        content: ""; }
      .fbform input[type="radio"] + label::before {
        border: 1px solid #dad9d6;
        width: 16px;
        height: 16px;
        pointer-events: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-color: #ebebeb; }
      .fbform input[type="radio"] + label::after {
        background-color: #ebebeb;
        transition: background-color .25s; }
    .fbform input[type="radio"]:checked + label::after {
      width: 8px;
      height: 8px;
      margin-top: .25rem;
      margin-left: .25rem;
      border: 1px solid #555;
      background-color: #555; }
    .fbform input[type="radio"]:focus:not(:checked) + .custom-control-label::before {
      border-color: #80bdff;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
    .fbform input[type="radio"]:focus + label::before {
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25); }
  .fbform input::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #dad9d6;
    opacity: 1;
    /* Firefox */ }
  .fbform input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #dad9d6; }
  .fbform input::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #dad9d6; }
  .fbform textarea {
    border-radius: 0px;
    border-color: #bababa;
    padding: .75rem .5rem; }
  .fbform select {
    width: 100%;
    border: 1px solid #bababa;
    height: 34px;
    border-radius: 0px;
    padding: 0 .5rem;
    position: relative;
    background: transparent;
    background-image: linear-gradient(45deg, transparent 50%, #000 50%), linear-gradient(135deg, #000 50%, transparent 50%);
    background-position: calc(100% - 15px) calc(.75em + 2px), calc(100% - 10px) calc(.75em + 2px);
    background-size: 5px 5px, 5px 5px;
    background-repeat: no-repeat; }
  .fbform button,
  .fbform input[type="submit"] {
    background: #0046ad;
    border: 0px;
    font-family: "Open Sans";
    font-weight: 600;
    transition: background-color .25s;
    padding: 6px 20px; }
    .fbform button:hover,
    .fbform input[type="submit"]:hover {
      background: #333; }
  .fbform .reqNote span {
    color: #E4002B;
    font-size: 14px;
    display: inline;
    margin-right: 3px;
    line-height: 24px;
    font-weight: normal;
    vertical-align: top; }
  .fbform .spacer {
    height: 30px; }
  .fbform .vMSG {
    display: none; }
  .fbform .invalid {
    border: 1px solid #E4002B !important; }
  .fbform .invalid ~ .vMSG {
    display: block;
    color: #E4002B;
    font-size: .875em;
    padding: 5px 0px; }
    .fbform .invalid ~ .vMSG:before {
      display: inline-block;
      height: 1.25em;
      width: 1.25em;
      content: '!';
      color: #fff;
      background: #E4002B;
      border-radius: 25px;
      text-align: center;
      margin-right: 5px; }
  .fbform .privacyStatement {
    background: #f1f1f1;
    padding: 15px; }
  .fbform a {
    font-weight: bold;
    color: #0046ad; }
    .fbform a:hover {
      color: #fff;
      background: #0046ad;
      text-decoration: none; }


</style>